import AJAX_Applications from "./JavaScript/AJAX_Applications.jsx";
import AJAX_ASP from "./JavaScript/AJAX_ASP.jsx";
import AJAX_Database from "./JavaScript/AJAX_Database.jsx";
import AJAX_Examples from "./JavaScript/AJAX_Examples.jsx";
import AJAX_Intro from "./JavaScript/AJAX_Intro.jsx";
import AJAX_PHP from "./JavaScript/AJAX_PHP.jsx";
import AJAX_Request from "./JavaScript/AJAX_Request.jsx";
import AJAX_Response from "./JavaScript/AJAX_Response.jsx";
import AJAX_XMLHttp from "./JavaScript/AJAX_XMLHttp.jsx";
import AJAX_XML_File from "./JavaScript/AJAX_XML_File.jsx";
import DOM_Animations from "./JavaScript/DOM_Animations.jsx";
import DOM_Collections from "./JavaScript/DOM_Collections.jsx";
import DOM_CSS from "./JavaScript/DOM_CSS.jsx";
import DOM_Document from "./JavaScript/DOM_Document.jsx";
import DOM_Elements from "./JavaScript/DOM_Elements.jsx";
import DOM_Events from "./JavaScript/DOM_Events.jsx";
import DOM_Event_Listener from "./JavaScript/DOM_Event_Listener.jsx";
import DOM_Forms from "./JavaScript/DOM_Forms.jsx";
import DOM_HTML from "./JavaScript/DOM_HTML.jsx";
import DOM_Intro from "./JavaScript/DOM_Intro.jsx";
import DOM_Methods from "./JavaScript/DOM_Methods.jsx";
import DOM_Navigation from "./JavaScript/DOM_Navigation.jsx";
import DOM_Nodes from "./JavaScript/DOM_Nodes.jsx";
import DOM_Node_Lists from "./JavaScript/DOM_Node_Lists.jsx";
import Function_Apply from "./JavaScript/Function_Apply.jsx";
import Function_Arrows from "./JavaScript/Function_Arrows.jsx";
import Function_Bind from "./JavaScript/Function_Bind.jsx";
import Function_Call from "./JavaScript/Function_Call.jsx";
import Function_Closures from "./JavaScript/Function_Closures.jsx";
import Function_Definitions from "./JavaScript/Function_Definitions.jsx";
import Function_Invocation from "./JavaScript/Function_Invocation.jsx";
import Function_Parameters from "./JavaScript/Function_Parameters.jsx";
import Function_this from "./JavaScript/Function_this.jsx";
import HTML_DOM_Objects from "./JavaScript/HTML_DOM_Objects.jsx";
import JavaScript from "./JavaScript/JavaScript.jsx";
import JavaScript_Objects from "./JavaScript/JavaScript_Objects.jsx";
import jQuery_CSS from "./JavaScript/jQuery_CSS.jsx";
import jQuery_DOM from "./JavaScript/jQuery_DOM.jsx";
import jQuery_HTML from "./JavaScript/jQuery_HTML.jsx";
import jQuery_Selectors from "./JavaScript/jQuery_Selectors.jsx";
import JSON_Arrays from "./JavaScript/JSON_Arrays.jsx";
import JSON_Data_Types from "./JavaScript/JSON_Data_Types.jsx";
import JSON_HTML from "./JavaScript/JSON_HTML.jsx";
import JSON_Intro from "./JavaScript/JSON_Intro.jsx";
import JSON_JSONP from "./JavaScript/JSON_JSONP.jsx";
import JSON_Objects from "./JavaScript/JSON_Objects.jsx";
import JSON_Parse from "./JavaScript/JSON_Parse.jsx";
import JSON_PHP from "./JavaScript/JSON_PHP.jsx";
import JSON_Server from "./JavaScript/JSON_Server.jsx";
import JSON_Stringify from "./JavaScript/JSON_Stringify.jsx";
import JSON_Syntax from "./JavaScript/JSON_Syntax.jsx";
import JSON_vs_XML from "./JavaScript/JSON_vs_XML.jsx";
import JS_2009_ES5 from "./JavaScript/JS_2009_ES5.jsx";
import JS_2015_ES6 from "./JavaScript/JS_2015_ES6.jsx";
import JS_2016 from "./JavaScript/JS_2016.jsx";
import JS_2017 from "./JavaScript/JS_2017.jsx";
import JS_2018 from "./JavaScript/JS_2018.jsx";
import JS_2019 from "./JavaScript/JS_2019.jsx";
import JS_2020 from "./JavaScript/JS_2020.jsx";
import JS_2021 from "./JavaScript/JS_2021.jsx";
import JS_2022 from "./JavaScript/JS_2022.jsx";
import JS_2023 from "./JavaScript/JS_2023.jsx";
import JS_2024 from "./JavaScript/JS_2024.jsx";
import JS_2025 from "./JavaScript/JS_2025.jsx";
import JS_Arithmetic_Operators from "./JavaScript/JS_Arithmetic_Operators.jsx";

import JS_Arrays from "./JavaScript/JS_Arrays.jsx";
import JS_Array_Const from "./JavaScript/JS_Array_Const.jsx";
import JS_Array_Iterations from "./JavaScript/JS_Array_Iterations.jsx";
import JS_Array_Methods from "./JavaScript/JS_Array_Methods.jsx";
import JS_Array_Reference from "./JavaScript/JS_Array_Reference.jsx";
import JS_Array_Search from "./JavaScript/JS_Array_Search.jsx";
import JS_Array_Sort from "./JavaScript/JS_Array_Sort.jsx";

import JS_Asynchronous from "./JavaScript/JS_Asynchronous.jsx";
import JS_Async_Await from "./JavaScript/JS_Async_Await.jsx";
import JS_Best_Practices from "./JavaScript/JS_Best_Practices.jsx";
import JS_BigInt from "./JavaScript/JS_BigInt.jsx";
import JS_Bitwise from "./JavaScript/JS_Bitwise.jsx";
import JS_Bitwise_Operators from "./JavaScript/JS_Bitwise_Operators.jsx";
import JS_Booleans from "./JavaScript/JS_Booleans.jsx";
import JS_Bootcamp from "./JavaScript/JS_Bootcamp.jsx";
import JS_Break from "./JavaScript/JS_Break.jsx";
import JS_Browser from "./JavaScript/JS_Browser.jsx";
import JS_Callbacks from "./JavaScript/JS_Callbacks.jsx";
import JS_Canvas from "./JavaScript/JS_Canvas.jsx";
import JS_Certificate from "./JavaScript/JS_Certificate.jsx";
import JS_Chart_js from "./JavaScript/JS_Chart_js.jsx";
import JS_Classes from "./JavaScript/JS_Classes.jsx";
import JS_Class_Inheritance from "./JavaScript/JS_Class_Inheritance.jsx";
import JS_Class_Static from "./JavaScript/JS_Class_Static.jsx";
import JS_Code_Blocks from "./JavaScript/JS_Code_Blocks.jsx";
import JS_Comments from "./JavaScript/JS_Comments.jsx";
import JS_Comparison from "./JavaScript/JS_Comparison.jsx";
import JS_Comparisons from "./JavaScript/JS_Comparisons.jsx";
import JS_Const from "./JavaScript/JS_Const.jsx";
import JS_Continue from "./JavaScript/JS_Continue.jsx";
import JS_Cookies from "./JavaScript/JS_Cookies.jsx";
import JS_D3_js from "./JavaScript/JS_D3_js.jsx";
import JS_Data_Types from "./JavaScript/JS_Data_Types.jsx";
import JS_Dates from "./JavaScript/JS_Dates.jsx";
import JS_Date_Formats from "./JavaScript/JS_Date_Formats.jsx";
import JS_Date_Get from "./JavaScript/JS_Date_Get.jsx";
import JS_Date_Reference from "./JavaScript/JS_Date_Reference.jsx";
import JS_Date_Set from "./JavaScript/JS_Date_Set.jsx";
import JS_Debugging from "./JavaScript/JS_Debugging.jsx";
import JS_Editor from "./JavaScript/JS_Editor.jsx";
import JS_Errors from "./JavaScript/JS_Errors.jsx";

import JS_Examples from "./JavaScript/JS_Examples.jsx";
import JS_Exercises from "./JavaScript/JS_Exercises.jsx";

import JS_Generators from "./JavaScript/JS_Generators.jsx";
import JS_Google_Chart from "./JavaScript/JS_Google_Chart.jsx";
import JS_Graphics from "./JavaScript/JS_Graphics.jsx";
import JS_History from "./JavaScript/JS_History.jsx";
import JS_History_2 from "./JavaScript/JS_History_2.jsx";
import JS_Hoisting from "./JavaScript/JS_Hoisting.jsx";
import JS_Home from "./JavaScript/JS_Home.jsx";
import JS_HTML_DOM from "./JavaScript/JS_HTML_DOM.jsx";
import JS_HTML_Events from "./JavaScript/JS_HTML_Events.jsx";
import JS_HTML_Input from "./JavaScript/JS_HTML_Input.jsx";
import JS_HTML_Objects from "./JavaScript/JS_HTML_Objects.jsx";
import JS_IE_Edge from "./JavaScript/JS_IE_Edge.jsx";
import JS_If_Else from "./JavaScript/JS_If_Else.jsx";

import JS_Interview_Prep from "./JavaScript/JS_Interview_Prep.jsx";
import JS_Introduction from "./JavaScript/JS_Introduction.jsx";

import JS_Keywords_Reference from "./JavaScript/JS_Keywords_Reference.jsx";
import JS_Keywords_Reserved from "./JavaScript/JS_Keywords_Reserved.jsx";
import JS_Let from "./JavaScript/JS_Let.jsx";
import JS_Location from "./JavaScript/JS_Location.jsx";
import JS_Logical from "./JavaScript/JS_Logical.jsx";
import JS_Logical_Operators from "./JavaScript/JS_Logical_Operators.jsx";
import JS_Loops from "./JavaScript/JS_Loops.jsx";

import JS_Loop_for from "./JavaScript/JS_Loop_for.jsx";
import JS_Loop_for_in from "./JavaScript/JS_Loop_for_in.jsx";
import JS_Loop_for_of from "./JavaScript/JS_Loop_for_of.jsx";
import JS_Loop_while from "./JavaScript/JS_Loop_while.jsx";
import JS_Maps from "./JavaScript/JS_Maps.jsx";
import JS_Map_Methods from "./JavaScript/JS_Map_Methods.jsx";
import JS_Map_Reference from "./JavaScript/JS_Map_Reference.jsx";
import JS_Map_WeakMap from "./JavaScript/JS_Map_WeakMap.jsx";
import JS_Math from "./JavaScript/JS_Math.jsx";
import JS_Math_Reference from "./JavaScript/JS_Math_Reference.jsx";
import JS_Mistakes from "./JavaScript/JS_Mistakes.jsx";
import JS_Modules from "./JavaScript/JS_Modules.jsx";
import JS_Navigator from "./JavaScript/JS_Navigator.jsx";
import JS_News_2025_2015 from "./JavaScript/JS_News_2025_2015.jsx";
import JS_Numbers from "./JavaScript/JS_Numbers.jsx";
import JS_Number_Methods from "./JavaScript/JS_Number_Methods.jsx";
import JS_Number_Properties from "./JavaScript/JS_Number_Properties.jsx";
import JS_Number_Reference from "./JavaScript/JS_Number_Reference.jsx";
import JS_Objects from "./JavaScript/JS_Objects.jsx";
import JS_Operators from "./JavaScript/JS_Operators.jsx";

import JS_Output from "./JavaScript/JS_Output.jsx";
import JS_Performance from "./JavaScript/JS_Performance.jsx";
import JS_Plotly from "./JavaScript/JS_Plotly.jsx";
import JS_Popup_Alert from "./JavaScript/JS_Popup_Alert.jsx";
import JS_Promises from "./JavaScript/JS_Promises.jsx";
import JS_Quiz from "./JavaScript/JS_Quiz.jsx";
import JS_Random from "./JavaScript/JS_Random.jsx";
import JS_RegExp from "./JavaScript/JS_RegExp.jsx";
import JS_RegExp_Assertions from "./JavaScript/JS_RegExp_Assertions.jsx";
import JS_RegExp_Classes from "./JavaScript/JS_RegExp_Classes.jsx";
import JS_RegExp_Flags from "./JavaScript/JS_RegExp_Flags.jsx";
import JS_RegExp_Metachars from "./JavaScript/JS_RegExp_Metachars.jsx";
import JS_RegExp_Methods from "./JavaScript/JS_RegExp_Methods.jsx";
import JS_RegExp_Objects from "./JavaScript/JS_RegExp_Objects.jsx";
import JS_RegExp_Patterns from "./JavaScript/JS_RegExp_Patterns.jsx";
import JS_RegExp_Quantifiers from "./JavaScript/JS_RegExp_Quantifiers.jsx";
import JS_Scope from "./JavaScript/JS_Scope.jsx";
import JS_Scopes from "./JavaScript/JS_Scopes.jsx";
import JS_Screen from "./JavaScript/JS_Screen.jsx";
import JS_Sets from "./JavaScript/JS_Sets.jsx";
import JS_Set_Logic from "./JavaScript/JS_Set_Logic.jsx";
import JS_Set_Methods from "./JavaScript/JS_Set_Methods.jsx";
import JS_Set_Reference from "./JavaScript/JS_Set_Reference.jsx";
import JS_Set_WeakSet from "./JavaScript/JS_Set_WeakSet.jsx";
import JS_Statements from "./JavaScript/JS_Statements.jsx";

import JS_Strict_Mode from "./JavaScript/JS_Strict_Mode.jsx";
import JS_Strings from "./JavaScript/JS_Strings.jsx";
import JS_String_Methods from "./JavaScript/JS_String_Methods.jsx";
import JS_String_Reference from "./JavaScript/JS_String_Reference.jsx";
import JS_String_Search from "./JavaScript/JS_String_Search.jsx";
import JS_String_Templates from "./JavaScript/JS_String_Templates.jsx";
import JS_Study_Plan from "./JavaScript/JS_Study_Plan.jsx";
import JS_Style_Guide from "./JavaScript/JS_Style_Guide.jsx";
import JS_Switch from "./JavaScript/JS_Switch.jsx";
import JS_Syllabus from "./JavaScript/JS_Syllabus.jsx";
import JS_Syntax from "./JavaScript/JS_Syntax.jsx";
import JS_Timing from "./JavaScript/JS_Timing.jsx";
import JS_toString from "./JavaScript/JS_toString.jsx";
import JS_Typed_Arrays from "./JavaScript/JS_Typed_Arrays.jsx";
import JS_Typed_Methods from "./JavaScript/JS_Typed_Methods.jsx";
import JS_Typed_Reference from "./JavaScript/JS_Typed_Reference.jsx";
import JS_typeof from "./JavaScript/JS_typeof.jsx";
import JS_Type_Conversion from "./JavaScript/JS_Type_Conversion.jsx";
import JS_UTF_8_Characters from "./JavaScript/JS_UTF_8_Characters.jsx";
import JS_Variables from "./JavaScript/JS_Variables.jsx";
import JS_Versions from "./JavaScript/JS_Versions.jsx";
import JS_Website from "./JavaScript/JS_Website.jsx";
import JS_Where_To from "./JavaScript/JS_Where_To.jsx";
import JS_Window from "./JavaScript/JS_Window.jsx";
import Object_Constructors from "./JavaScript/Object_Constructors.jsx";

import Object_Destructuring from "./JavaScript/Object_Destructuring.jsx";
import Object_Display from "./JavaScript/Object_Display.jsx";
import Object_Get_Set from "./JavaScript/Object_Get_Set.jsx";
import Object_Iterations from "./JavaScript/Object_Iterations.jsx";
import Object_Management from "./JavaScript/Object_Management.jsx";
import Object_Methods from "./JavaScript/Object_Methods.jsx";
import Object_Properties from "./JavaScript/Object_Properties.jsx";
import Object_Protection from "./JavaScript/Object_Protection.jsx";
import Object_Prototypes from "./JavaScript/Object_Prototypes.jsx";
import Object_Reference from "./JavaScript/Object_Reference.jsx";
import Object_this from "./JavaScript/Object_this.jsx";
import Web_API_Intro from "./JavaScript/Web_API_Intro.jsx";
import Web_Fetch_API from "./JavaScript/Web_Fetch_API.jsx";
import Web_Geolocation_API from "./JavaScript/Web_Geolocation_API.jsx";
import Web_History_API from "./JavaScript/Web_History_API.jsx";
import Web_Storage_API from "./JavaScript/Web_Storage_API.jsx";
import Web_Validation_API from "./JavaScript/Web_Validation_API.jsx";
import Web_Worker_API from "./JavaScript/Web_Worker_API.jsx";
import JS_Var from "./JavaScript/JS_Var.jsx";
import JS_Assignment_Operators from "./JavaScript/JS_Assignment_Operators.jsx";
import JS_Comparison_Operators from "./JavaScript/JS_Comparison_Operators.jsx";
import JS_And_HTML_Events from "./JavaScript/JS_And_HTML_Events.jsx";
import JS_Events from "./JavaScript/JS_Events.jsx";
import JS_OOPs from "./JavaScript/JS_OOPs.jsx";
import JS_Class from "./JavaScript/JS_Class.jsx";
import JS_Object from "./JavaScript/JS_Object.jsx";
import JS_Constructor from "./JavaScript/JS_Constructor.jsx";
import JS_Prototype from "./JavaScript/JS_Prototype.jsx";
import JS_Inheritance from "./JavaScript/JS_Inheritance.jsx";
import JS_Encapsulation from "./JavaScript/JS_Encapsulation.jsx";
import JS_Abstraction from "./JavaScript/JS_Abstraction.jsx";
import JS_Polymorphism from "./JavaScript/JS_Polymorphism.jsx";
import JS_This from "./JavaScript/JS_This.jsx";
import JS_Super from "./JavaScript/JS_Super.jsx";
import JS_Static_Methods from "./JavaScript/JS_Static_Methods.jsx";
import JS_Getters_Setters from "./JavaScript/JS_Getters_Setters.jsx";

import JS_OOPs_Examples from "./JavaScript/JS_OOPs_Examples.jsx";
import JS_OOPs_Reference from "./JavaScript/JS_OOPs_Reference.jsx";
// ✅ JS Higher Order Functions Imports
import JS_Higher_Order_Functions from "./JavaScript/JS_Higher_Order_Functions.jsx";
import JS_forEach from "./JavaScript/JS_forEach.jsx";
import JS_map from "./JavaScript/JS_map.jsx";
import JS_filter from "./JavaScript/JS_filter.jsx";
import JS_reduce from "./JavaScript/JS_reduce.jsx";
import JS_some from "./JavaScript/JS_some.jsx";
import JS_every from "./JavaScript/JS_every.jsx";
import JS_find from "./JavaScript/JS_find.jsx";
import JS_findIndex from "./JavaScript/JS_findIndex.jsx";
import JS_sort from "./JavaScript/JS_sort.jsx";
import JS_flatMap from "./JavaScript/JS_flatMap.jsx";
import JS_Higher_Order_Reference from "./JavaScript/JS_Higher_Order_Reference.jsx";
import Condition from "./JavaScript/Condition.jsx";
import JS_NestedIf from "./JavaScript/JS_NestedIf.jsx";
import JS_If from "./JavaScript/JS_If.jsx";
import JS_If_Else_If_Else from "./JavaScript/JS_If_Else_If_Else.jsx";
import JS_Ternary from "./JavaScript/JS_Ternary.jsx";
import JS_NestedTernary from "./JavaScript/JS_NestedTernary.jsx";
import JS_Named_Function from "./JavaScript/JS_Named_Function.jsx";

import JS_Function from "./JavaScript/JS_Function.jsx";

// ✅ Map
const JavaScriptComponentsMap = {
  "<JS_Higher_Order_Functions />": JS_Higher_Order_Functions,
  "<JS_forEach />": JS_forEach,
  "<JS_map />": JS_map,
  "<JS_filter />": JS_filter,
  "<JS_reduce />": JS_reduce,
  "<JS_some />": JS_some,
  "<JS_every />": JS_every,
  "<JS_find />": JS_find,
  "<JS_findIndex />": JS_findIndex,
  "<JS_sort />": JS_sort,
  "<JS_flatMap />": JS_flatMap,
  "<JS_Higher_Order_Reference />": JS_Higher_Order_Reference,

  "<JS_OOPs />": JS_OOPs,
  "<JS_Class />": JS_Class,
  "<JS_Object />": JS_Object,
  "<JS_Constructor />": JS_Constructor,
  "<JS_Prototype />": JS_Prototype,
  "<JS_Inheritance />": JS_Inheritance,
  "<JS_Encapsulation />": JS_Encapsulation,
  "<JS_Abstraction />": JS_Abstraction,
  "<JS_Polymorphism />": JS_Polymorphism,
  "<JS_This />": JS_This,
  "<JS_Super />": JS_Super,
  "<JS_Static_Methods />": JS_Static_Methods,
  "<JS_Getters_Setters />": JS_Getters_Setters,

  "<JS_OOPs_Examples />": JS_OOPs_Examples,
  "<JS_OOPs_Reference />": JS_OOPs_Reference,

  "<AJAX_Applications />": AJAX_Applications,
  "<JS_And_HTML_Events />": JS_And_HTML_Events,
  "<AJAX_ASP />": AJAX_ASP,
  "<JS_Comparison_Operators />": JS_Comparison_Operators,
  "<AJAX_Database />": AJAX_Database,
  "<AJAX_Examples />": AJAX_Examples,
  "<AJAX_Intro />": AJAX_Intro,
  "<AJAX_PHP />": AJAX_PHP,
  "<JS_Var />": JS_Var,
  "<AJAX_Request />": AJAX_Request,
  "<AJAX_Response />": AJAX_Response,
  "<AJAX_XMLHttp />": AJAX_XMLHttp,
  "<AJAX_XML_File />": AJAX_XML_File,
  "<DOM_Animations />": DOM_Animations,
  "<DOM_Collections />": DOM_Collections,
  "<DOM_CSS />": DOM_CSS,
  "<DOM_Document />": DOM_Document,
  "<DOM_Elements />": DOM_Elements,
  "<DOM_Events />": DOM_Events,
  "<DOM_Event_Listener />": DOM_Event_Listener,
  "<DOM_Forms />": DOM_Forms,
  "<DOM_HTML />": DOM_HTML,
  "<DOM_Intro />": DOM_Intro,
  "<DOM_Methods />": DOM_Methods,
  "<DOM_Navigation />": DOM_Navigation,
  "<DOM_Nodes />": DOM_Nodes,
  "<DOM_Node_Lists />": DOM_Node_Lists,
  "<Function_Apply />": Function_Apply,
  "<Function_Arrows />": Function_Arrows,
  "<JS_Function />": JS_Function,
  "<JS_Named_Function />": JS_Named_Function,
  "<Function_Bind />": Function_Bind,
  "<Function_Call />": Function_Call,
  "<Function_Closures />": Function_Closures,
  "<Function_Definitions />": Function_Definitions,
  "<Function_Invocation />": Function_Invocation,
  "<Function_Parameters />": Function_Parameters,
  "<Function_this />": Function_this,
  "<HTML_DOM_Objects />": HTML_DOM_Objects,
  "<JavaScript />": JavaScript,
  "<JavaScript_Objects />": JavaScript_Objects,
  "<jQuery_CSS />": jQuery_CSS,
  "<jQuery_DOM />": jQuery_DOM,
  "<jQuery_HTML />": jQuery_HTML,
  "<jQuery_Selectors />": jQuery_Selectors,
  "<JSON_Arrays />": JSON_Arrays,
  "<JSON_Data_Types />": JSON_Data_Types,
  "<JSON_HTML />": JSON_HTML,
  "<JSON_Intro />": JSON_Intro,
  "<JSON_JSONP />": JSON_JSONP,
  "<JSON_Objects />": JSON_Objects,
  "<JSON_Parse />": JSON_Parse,
  "<JSON_PHP />": JSON_PHP,
  "<JSON_Server />": JSON_Server,
  "<JSON_Stringify />": JSON_Stringify,
  "<JSON_Syntax />": JSON_Syntax,
  "<JSON_vs_XML />": JSON_vs_XML,
  "<JS_2009_ES5 />": JS_2009_ES5,
  "<JS_2015_ES6 />": JS_2015_ES6,
  "<JS_2016 />": JS_2016,
  "<JS_2017 />": JS_2017,
  "<JS_2018 />": JS_2018,
  "<JS_2019 />": JS_2019,
  "<JS_2020 />": JS_2020,
  "<JS_2021 />": JS_2021,
  "<JS_2022 />": JS_2022,
  "<JS_2023 />": JS_2023,
  "<JS_2024 />": JS_2024,
  "<JS_2025 />": JS_2025,
  "<JS_Arithmetic_Operators />": JS_Arithmetic_Operators,

  "<JS_Arrays />": JS_Arrays,
  "<JS_Array_Const />": JS_Array_Const,
  "<JS_Array_Iterations />": JS_Array_Iterations,
  "<JS_Array_Methods />": JS_Array_Methods,
  "<JS_Array_Reference />": JS_Array_Reference,
  "<JS_Array_Search />": JS_Array_Search,
  "<JS_Array_Sort />": JS_Array_Sort,
  "<JS_Assignment_Operators />": JS_Assignment_Operators,

  "<JS_Asynchronous />": JS_Asynchronous,
  "<JS_Async_Await />": JS_Async_Await,
  "<JS_Best_Practices />": JS_Best_Practices,
  "<JS_BigInt />": JS_BigInt,
  "<JS_Bitwise />": JS_Bitwise,
  "<JS_Bitwise_Operators />": JS_Bitwise_Operators,
  "<JS_Booleans />": JS_Booleans,
  "<JS_Bootcamp />": JS_Bootcamp,
  "<JS_Break />": JS_Break,
  "<JS_Browser />": JS_Browser,
  "<JS_Callbacks />": JS_Callbacks,
  "<JS_Canvas />": JS_Canvas,
  "<JS_Certificate />": JS_Certificate,
  "<JS_Chart_js />": JS_Chart_js,
  "<JS_Classes />": JS_Classes,
  "<JS_Class_Inheritance />": JS_Class_Inheritance,
  "<JS_Class_Static />": JS_Class_Static,
  "<JS_Code_Blocks />": JS_Code_Blocks,
  "<JS_Comments />": JS_Comments,
  "<JS_Comparison />": JS_Comparison,
  "<JS_Comparisons />": JS_Comparisons,
  "<JS_Const />": JS_Const,
  "<JS_Continue />": JS_Continue,
  "<JS_Cookies />": JS_Cookies,
  "<JS_D3_js />": JS_D3_js,
  "<JS_Data_Types />": JS_Data_Types,
  "<JS_Dates />": JS_Dates,
  "<JS_Date_Formats />": JS_Date_Formats,
  "<JS_Date_Get />": JS_Date_Get,
  "<JS_Date_Reference />": JS_Date_Reference,
  "<JS_Date_Set />": JS_Date_Set,
  "<JS_Debugging />": JS_Debugging,
  "<JS_Editor />": JS_Editor,
  "<JS_Errors />": JS_Errors,
  "<JS_Events />": JS_Events,
  "<JS_Examples />": JS_Examples,
  "<JS_Exercises />": JS_Exercises,

  "<JS_Generators />": JS_Generators,
  "<JS_Google_Chart />": JS_Google_Chart,
  "<JS_Graphics />": JS_Graphics,
  "<JS_History />": JS_History,
  "<JS_History_2 />": JS_History_2,
  "<JS_Hoisting />": JS_Hoisting,
  "<JS_Home />": JS_Home,
  "<JS_HTML_DOM />": JS_HTML_DOM,
  "<JS_HTML_Events />": JS_HTML_Events,
  "<JS_HTML_Input />": JS_HTML_Input,
  "<JS_HTML_Objects />": JS_HTML_Objects,
  "<JS_IE_Edge />": JS_IE_Edge,
  "<JS_If />": JS_If,
  "<JS_If_Else />": JS_If_Else,
  "<JS_If_Else_If_Else />": JS_If_Else_If_Else,
  "<JS_Ternary />": JS_Ternary,
  "<JS_NestedTernary />": JS_NestedTernary,

  "<JS_NestedIf />": JS_NestedIf,
  "<JS_Interview_Prep />": JS_Interview_Prep,
  "<JS_Introduction />": JS_Introduction,
  "<JS_Keywords_Reference />": JS_Keywords_Reference,
  "<JS_Keywords_Reserved />": JS_Keywords_Reserved,
  "<JS_Let />": JS_Let,
  "<JS_Location />": JS_Location,
  "<JS_Logical />": JS_Logical,
  "<JS_Logical_Operators />": JS_Logical_Operators,
  "<JS_Loops />": JS_Loops,

  "<JS_Loop_for />": JS_Loop_for,
  "<JS_Loop_for_in />": JS_Loop_for_in,
  "<JS_Loop_for_of />": JS_Loop_for_of,
  "<JS_Loop_while />": JS_Loop_while,
  "<JS_Maps />": JS_Maps,
  "<JS_Map_Methods />": JS_Map_Methods,
  "<JS_Map_Reference />": JS_Map_Reference,
  "<JS_Map_WeakMap />": JS_Map_WeakMap,
  "<JS_Math />": JS_Math,
  "<JS_Math_Reference />": JS_Math_Reference,
  "<JS_Mistakes />": JS_Mistakes,
  "<JS_Modules />": JS_Modules,
  "<JS_Navigator />": JS_Navigator,
  "<JS_News_2025_2015 />": JS_News_2025_2015,
  "<JS_Numbers />": JS_Numbers,
  "<JS_Number_Methods />": JS_Number_Methods,
  "<JS_Number_Properties />": JS_Number_Properties,
  "<JS_Number_Reference />": JS_Number_Reference,
  "<JS_Objects />": JS_Objects,
  "<JS_Operators />": JS_Operators,

  "<JS_Output />": JS_Output,
  "<JS_Performance />": JS_Performance,
  "<JS_Plotly />": JS_Plotly,
  "<JS_Popup_Alert />": JS_Popup_Alert,
  "<JS_Promises />": JS_Promises,
  "<JS_Quiz />": JS_Quiz,
  "<JS_Random />": JS_Random,
  "<JS_RegExp />": JS_RegExp,
  "<JS_RegExp_Assertions />": JS_RegExp_Assertions,
  "<JS_RegExp_Classes />": JS_RegExp_Classes,
  "<JS_RegExp_Flags />": JS_RegExp_Flags,
  "<JS_RegExp_Metachars />": JS_RegExp_Metachars,
  "<JS_RegExp_Methods />": JS_RegExp_Methods,
  "<JS_RegExp_Objects />": JS_RegExp_Objects,
  "<JS_RegExp_Patterns />": JS_RegExp_Patterns,
  "<JS_RegExp_Quantifiers />": JS_RegExp_Quantifiers,
  "<JS_Scope />": JS_Scope,
  "<JS_Scopes />": JS_Scopes,
  "<JS_Screen />": JS_Screen,
  "<JS_Sets />": JS_Sets,
  "<JS_Set_Logic />": JS_Set_Logic,
  "<JS_Set_Methods />": JS_Set_Methods,
  "<JS_Set_Reference />": JS_Set_Reference,
  "<JS_Set_WeakSet />": JS_Set_WeakSet,
  "<JS_Statements />": JS_Statements,
  "<Condition />": Condition,

  "<JS_Strict_Mode />": JS_Strict_Mode,
  "<JS_Strings />": JS_Strings,
  "<JS_String_Methods />": JS_String_Methods,
  "<JS_String_Reference />": JS_String_Reference,
  "<JS_String_Search />": JS_String_Search,
  "<JS_String_Templates />": JS_String_Templates,
  "<JS_Study_Plan />": JS_Study_Plan,
  "<JS_Style_Guide />": JS_Style_Guide,
  "<JS_Switch />": JS_Switch,
  "<JS_Syllabus />": JS_Syllabus,
  "<JS_Syntax />": JS_Syntax,
  "<JS_Timing />": JS_Timing,
  "<JS_toString />": JS_toString,
  "<JS_Typed_Arrays />": JS_Typed_Arrays,
  "<JS_Typed_Methods />": JS_Typed_Methods,
  "<JS_Typed_Reference />": JS_Typed_Reference,
  "<JS_typeof />": JS_typeof,
  "<JS_Type_Conversion />": JS_Type_Conversion,
  "<JS_UTF_8_Characters />": JS_UTF_8_Characters,
  "<JS_Variables />": JS_Variables,
  "<JS_Versions />": JS_Versions,
  "<JS_Website />": JS_Website,
  "<JS_Where_To />": JS_Where_To,
  "<JS_Window />": JS_Window,
  "<Object_Constructors />": Object_Constructors,

  "<Object_Destructuring />": Object_Destructuring,
  "<Object_Display />": Object_Display,
  "<Object_Get_Set />": Object_Get_Set,
  "<Object_Iterations />": Object_Iterations,
  "<Object_Management />": Object_Management,
  "<Object_Methods />": Object_Methods,
  "<Object_Properties />": Object_Properties,
  "<Object_Protection />": Object_Protection,
  "<Object_Prototypes />": Object_Prototypes,
  "<Object_Reference />": Object_Reference,
  "<Object_this />": Object_this,
  "<Web_API_Intro />": Web_API_Intro,
  "<Web_Fetch_API />": Web_Fetch_API,
  "<Web_Geolocation_API />": Web_Geolocation_API,
  "<Web_History_API />": Web_History_API,
  "<Web_Storage_API />": Web_Storage_API,
  "<Web_Validation_API />": Web_Validation_API,
  "<Web_Worker_API />": Web_Worker_API,
};

export default JavaScriptComponentsMap;
